// @owners { team: patients-team }
import { COLORS, SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, LgPadding, LgSpacing } from '@alto/design-system';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { IMG_ALT_TEXTS } from '~shared/constants';

export const FeeDetailsActionSheet = () => {
  return (
    <ActionSheetV2
      illustrationSrc={getImage('deliveryWoman')}
      illustrationAccessibilityLabel={IMG_ALT_TEXTS.deliveryWoman}
      analyticsName="fee details"
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body
          fontFamily="semibold"
          color={COLORS.TEXT_COLORS.PRIMARY}
        >
          About our delivery fees
        </Body>
        <LgSpacing />
        <Body>
          As part of our commitment to serving you with convenience and reliability, we charge delivery fees*. This
          allows us to provide urgent medication delivery when needed.
        </Body>
        <LgSpacing />
        <Body>
          *Some prescription savings and discount cards (like the Team Cuban card) are subject to additional delivery
          fees.
        </Body>
      </LgPadding>
    </ActionSheetV2>
  );
};
